export default "__VITE_ASSET__BtFS$StI__"